import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col p-4" }
const _hoisted_2 = { class: "flex flex-col space-y-8" }
const _hoisted_3 = { class: "flex flex-col w-full space-y-2" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "flex flex-col space-y-4" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col w-full space-y-2"
}
const _hoisted_7 = { class: "flex text-white text-xl font-medium" }
const _hoisted_8 = { class: "flex flex-wrap w-full" }
const _hoisted_9 = {
  key: 0,
  class: "flex"
}
const _hoisted_10 = { class: "flex mr-2.5 mb-2.5 justify-between p-4 py-2 rounded-full bg-brand-dark-gray text-white" }
const _hoisted_11 = { class: "my-auto text-lg font-medium" }
const _hoisted_12 = {
  key: 1,
  class: "flex"
}
const _hoisted_13 = { class: "flex mr-2.5 mb-2.5 justify-between p-4 py-2 rounded-full bg-brand-dark-gray text-white" }
const _hoisted_14 = { class: "my-auto text-lg font-medium" }
const _hoisted_15 = {
  key: 2,
  class: "flex"
}
const _hoisted_16 = { class: "flex mr-2.5 mb-2.5 justify-between p-4 py-2 rounded-full bg-brand-dark-gray text-white" }
const _hoisted_17 = { class: "my-auto text-lg font-medium" }
const _hoisted_18 = {
  key: 3,
  class: "flex"
}
const _hoisted_19 = { class: "flex mr-2.5 mb-2.5 justify-between p-4 py-2 rounded-full bg-brand-dark-gray text-white" }
const _hoisted_20 = { class: "my-auto text-lg font-medium" }
const _hoisted_21 = { class: "flex mr-2.5 mb-2.5 justify-between p-4 py-2 rounded-full bg-brand-dark-gray text-white space-x-1.5" }
const _hoisted_22 = { class: "flex" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "my-auto text-lg font-medium" }
const _hoisted_25 = {
  key: 0,
  class: "flex flex-col space-y-4"
}
const _hoisted_26 = { class: "flex flex-wrap w-full" }
const _hoisted_27 = { class: "my-auto text-lg font-medium" }
const _hoisted_28 = {
  key: 1,
  class: "flex flex-col space-y-4"
}
const _hoisted_29 = { class: "flex flex-wrap w-full" }
const _hoisted_30 = { class: "my-auto text-lg font-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex text-white text-xl font-medium" }, "Bio", -1)),
        _createElementVNode("div", {
          class: "text-brand-light-gray text-lg post-content",
          innerHTML: _ctx.sanitizeHtml(_ctx.bio)
        }, null, 8, _hoisted_4)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userRef.profiles, (profile, profileIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          key: profileIndex,
          class: "flex flex-col"
        }, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.userRef.profiles.length > 1 || profile.name !== _ctx.userRef.name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(profile.name), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              (profile.age)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, "Age " + _toDisplayString(profile.age), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (profile.pronouns)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(profile.pronouns.name), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (profile.gender)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(profile.gender.name), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (profile.sexuality)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(profile.sexuality.name), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profile.basic_info, (info) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex",
                  key: info.text
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", {
                        class: "w-4 h-4 m-auto",
                        innerHTML: info.icon
                      }, null, 8, _hoisted_23)
                    ]),
                    _createElementVNode("div", _hoisted_24, _toDisplayString(info.text), 1)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      }), 128)),
      (_ctx.showLookingFor)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex flex-col w-full space-y-2" }, [
              _createElementVNode("div", { class: "flex text-white text-xl font-medium" }, "Looking for")
            ], -1)),
            _createElementVNode("div", _hoisted_26, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user.sexual_interests, (interest, interestIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: interestIndex,
                  class: "flex mr-2.5 mb-2.5 justify-between p-4 py-2 rounded-full bg-brand-dark-gray text-white"
                }, [
                  _createElementVNode("div", _hoisted_27, _toDisplayString(interest.name), 1)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showKinks)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex flex-col w-full space-y-2" }, [
              _createElementVNode("div", { class: "flex text-white text-xl font-medium" }, "Kinks")
            ], -1)),
            _createElementVNode("div", _hoisted_29, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user.desires, (desire, desireIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: desireIndex,
                  class: "flex mr-2.5 mb-2.5 justify-between p-4 py-2 rounded-full bg-brand-dark-gray text-white"
                }, [
                  _createElementVNode("div", _hoisted_30, _toDisplayString(desire.name), 1)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}